export const HALO_GRADIENT =
  "linear-gradient(90deg, #b1e001 0%, #ff6d15 50%, #ff00c0 100%)";

export const OMBRE_GRADIENT =
  "linear-gradient(90deg, transparent 0%, rgba(177,224,1,0.07) 25%, rgba(255,109,21,0.12) 60%, rgba(255,0,192,0.18) 100%)";

/** Published by ImpersonationBar; reflects its real current height (0 when collapsed,
 * the measured expanded height when pinned) so this header always stacks below it. */
/** CSS custom property consumed by CourtesyNavigationHeader (and any other fixed-position
 * header content) so it stacks below this bar instead of overlapping it, regardless of
 * whether the bar is collapsed (hidden strip) or pinned/expanded.
 * Published by ImpersonationPin; reflects its real current height (0 when collapsed,
 * the measured expanded height when pinned) so this header always stacks below it.*/
export const IMPERSONATION_BAR_HEIGHT_CSS_VAR = "--shi-impersonation-bar-height";

export const TENANT_ID_UNDEFINED = "tenant";
